module.exports = __webpack_public_path__ + "img/icon_submenu8.59153871.svg";